import React, { FC } from 'react'

import { styled } from '@pixel/core/styles'
import LocalizedTypography from '../../components/LocalizedTypography'
import { LocalizedText } from '../../contexts/Localization/LocalizationTypes'

const AutomationLandingPageHeaderContainer = styled('section')(({ theme }: { theme: any }) => ({
    backgroundColor: 'white',
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    paddingBottom: theme.spacing(3),
}))

const TitleContainer = styled('div')(({ theme }: { theme: any }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
}))

const SubtitleText = styled(LocalizedTypography)({
    color: '#808080',
    size: '13px',
    fontWeight: 400,
})

interface AutomationLandingPageHeaderProps {

}
export const AutomationLandingPageHeader: FC<AutomationLandingPageHeaderProps> = ({
    children
}) => {
    return (
        <AutomationLandingPageHeaderContainer>
            <TitleContainer>
                <LocalizedTypography variant="h1" text={LocalizedText.AUTOMATION_TITLE} />
                {children}
            </TitleContainer>
            <SubtitleText variant="body1" text={LocalizedText.AUTOMATION_DESCRIPTION} />
        </AutomationLandingPageHeaderContainer>
    )
}

export default AutomationLandingPageHeader
